import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dailyQuestionApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateQuestion(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (question: string) =>
      dailyQuestionApiClient.create({ question, jobId }),
    onSettled: () => invalidateFor('question.save', qc, { jobId }),
  });
}

export function useDeleteQuestion(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (questionId: number) =>
      dailyQuestionApiClient.delete(questionId),
    onSettled: () => invalidateFor('question.save', qc, { jobId }),
  });
}
